export const $APP_NAME = "EzPay";
export const $__DEV__ = process.env.REACT_APP_ENV === "development";
export const $BASE_URL = `${process.env.REACT_APP_SERVER_URL}`;

export const I18N_LANGUAGES = {
    ar: "ar-SA",
    en: "en-US"
}

export const WEEK_DAYS = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"]